// src/plugins/permissions.js
import axios from 'axios';
import { reactive } from 'vue';

const state = reactive({
  role: null,
  roleLoaded: false
});

const roleHierarchy = {
  'usuario': 1,
  'administrador': 2,
  'administradorevento': 3,
  'superadministrador': 4
};

async function loadRole(roleToken) {
  if (!roleToken) {
    state.role = null;
    state.roleLoaded = true;
    return;
  }
  try {
    const response = await axios.post('/api/verify-role', { roleToken });
    state.role = response.data.role;
  } catch {
    state.role = null;
  } finally {
    state.roleLoaded = true;
  }
}

function canView(...expectedRoles) {
  if (!state.roleLoaded) return false;
  if (!state.role) return false;
  return expectedRoles.some(role => roleHierarchy[state.role] >= roleHierarchy[role]);
}

// Para acceder en composition API
function usePermissions() {
  return {
    role: state,
    canView
  };
}

export default {
  install: (app, options = {}) => {
    // Cargar el rol al iniciar la app (ej: desde localStorage, Vuex, o props)
    // Puedes pasar el roleToken desde main.js usando: app.use(permissionsPlugin, { roleToken: ... })
    loadRole(options.roleToken);

    // Añade los métodos globales
    app.config.globalProperties.$role = state;
    app.config.globalProperties.$canView = canView;

    // Composition API helper
    app.provide('permissions', { role: state, canView });
  },
  usePermissions // exporta para composition API
};
